import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M23 12.296c0 5.573-4.893 10.071-10.72 9.68-4.97-.342-8.98-4.253-9.257-9.069-.278-4.009 2.018-7.529 5.423-9.24.757-.367 1.665.146 1.665.978v.146c0 .416-.253.783-.631.978-2.573 1.32-4.288 3.985-4.086 7.016.252 3.667 3.33 6.625 7.088 6.869 4.414.269 8.096-3.129 8.096-7.358 0-2.811-1.639-5.256-4.06-6.502a1.173 1.173 0 0 1-.656-1.052c0-.88.958-1.442 1.74-1.026C20.805 5.354 23 8.58 23 12.296ZM13.011 0h-.075c-.757 0-1.362.587-1.362 1.32v8.287c0 .733.605 1.32 1.362 1.32h.075c.757 0 1.362-.587 1.362-1.32V1.32c0-.733-.605-1.32-1.362-1.32Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }